import * as utils from 'Utils';


export function getAovProgressBarPayloads(successCallback, errorCallback, apbId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`aov-progress-bar-payloads/${apbId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
